import { useMutation, useQuery } from "@tanstack/react-query";
import { customFetcher } from "../useFetch";
import { IMaterialDocument } from "../../interfaces/IMaterialDocument";
import { IMaterialSubcategory } from "../../interfaces/IMaterialSubcategory";
import { IMaterialCategory } from "../../interfaces/IMaterialCategory";
import { IMaterial } from "../../interfaces/IMaterial";

export const useGetMaterialDocument = () => {
    const {
        data: materialDocumentArray,
        isLoading: isLoadingMaterialDocumentArray,
        refetch: refetchMaterialDocument,
    } = useQuery<IMaterialDocument[]>({
        queryKey: ["material/document/"],
        queryFn: () => customFetcher({ endpoint: "/material/document/" }),
    });
    return { materialDocumentArray, isLoadingMaterialDocumentArray, refetchMaterialDocument };
};

//
// Fetch alle Materialien
//
export const useGetMaterials = () => {
    const {
        data: materialArray = [],
        isLoading: isLoadingMaterials,
        error: errorMaterials,
        refetch: refetchMaterials,
    } = useQuery<IMaterial[], Error>({
        queryKey: ["material/"],
        queryFn: () => customFetcher({ endpoint: "/material/" }),
        refetchOnWindowFocus: false,
        initialData: [],
    });

    return {
        materialArray,
        isLoadingMaterials,
        errorMaterials,
        refetchMaterials,
    };
};

//
// Fetch alle Material-Kategorien
//
export const useGetMaterialCategories = () => {
    const {
        data: materialCategoryArray = [],
        isLoading: isLoadingMaterialCategories,
        error: errorMaterialCategories,
        refetch: refetchMaterialCategories,
    } = useQuery<IMaterialCategory[], Error>({
        queryKey: ["material/category/"],
        queryFn: () => customFetcher({ endpoint: "/material/category/" }),
        refetchOnWindowFocus: false,
        initialData: [],
    });

    return {
        materialCategoryArray,
        isLoadingMaterialCategories,
        errorMaterialCategories,
        refetchMaterialCategories,
    };
};

//
// Fetch alle Material-Subkategorien
//
export const useGetMaterialSubcategories = () => {
    const {
        data: materialSubcategoryArray = [],
        isLoading: isLoadingMaterialSubcategories,
        error: errorMaterialSubcategories,
        refetch: refetchMaterialSubcategories,
    } = useQuery<IMaterialSubcategory[], Error>({
        queryKey: ["material/subcategory/"],
        queryFn: () => customFetcher({ endpoint: "/material/subcategory/" }),
        refetchOnWindowFocus: false,
        initialData: [],
    });

    return {
        materialSubcategoryArray,
        isLoadingMaterialSubcategories,
        errorMaterialSubcategories,
        refetchMaterialSubcategories,
    };
};
